// Mascara de telefone brasileiro.
// Persistimos apenas digitos no banco; mascara eh aplicada na UI.
// Suporta fixo (10 digitos) e celular (11 digitos).

export const onlyDigits = (value: string): string => value.replace(/\D/g, '');

/**
 * Formata progressivamente conforme o usuario digita. Aceita ate 11 digitos
 * (DDD + 9 + 4 + 4). Exemplos:
 *  "6"           -> "(6"
 *  "67"          -> "(67) "
 *  "6799999"     -> "(67) 9999-9"
 *  "67999990000" -> "(67) 99999-0000"
 *  "6733331111"  -> "(67) 3333-1111"
 */
export const formatPhoneBR = (value: string): string => {
  const digits = onlyDigits(value).slice(0, 11);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    // Fixo: (DD) NNNN-NNNN
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  // Celular: (DD) NNNNN-NNNN
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};
